import React, { PureComponent } from 'react';

import ImageGallery from '../../components/ImageGallery';

/**
  * Image gallery container component.
  * Wraps the image gallery presentational component with state to control visibility.
 */
class ImageGalleryContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      currentImage: 0,
      isOpen: false,
    };
  }

  handleClose = () => {
    this.setState({
      isOpen: false,
    });
  };

  handleNext = () => {
    this.setState(({ currentImage }) => ({
      currentImage: currentImage + 1,
    }));
  };

  handleOpen = () => {
    this.setState({
      isOpen: true,
    });
  };

  handlePrev = () => {
    this.setState(({ currentImage }) => ({
      currentImage: currentImage - 1,
    }));
  };

  render() {
    return (
      <ImageGallery
        onButtonClick={this.handleOpen}
        onClickNext={this.handleNext}
        onClickPrev={this.handlePrev}
        onClose={this.handleClose}
        {...this.props}
        {...this.state}
      />
    );
  }
}

export default ImageGalleryContainer;



// WEBPACK FOOTER //
// ./app/src/containers/ImageGallery/index.jsx